(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["size-chart"]) return;
  try {
    
  $('#sizeChartLink, a[href$="/womens-top-size-chart"], a[href$="/womens-bottom-size-chart"], a[href$="/mens-top-size-chart"], a[href$="/mens-bottom-size-chart"]').on('click', (e)=> {
    
    e.preventDefault();
    $('#sizeChart').show();
    console.log('href=>', $(this).attr('title'), e.target.href);

    if(e.target.href.indexOf('womens-top-size-chart') > -1){
      $('.size-chart-container').hide();
      $('.size-chart-container[data-vendor="nvo"][data-heading="top size chart"]').show();
    } else if(e.target.href.indexOf('womens-bottom-size-chart') > -1){
      $('.size-chart-container').hide();
      $('.size-chart-container[data-vendor="nvo"][data-heading="bottom size chart"]').show();
    } else if(e.target.href.indexOf('mens-top-size-chart') > -1){
      $('.size-chart-container').hide();
      $('.size-chart-container[data-vendor="sligo"][data-heading="sligo tops"]').show();
    } else if(e.target.href.indexOf('mens-bottom-size-chart') > -1){
      $('.size-chart-container').hide();
      $('.size-chart-container[data-vendor="sligo"][data-heading="sligo bottom"]').show();
    }
  });

  $('#sizeChartClose').on('click', ()=> {
    $('#sizeChart').hide();
  }); 

  $('#centimeters, #inches').on('click', function() {
    let elem  = $(this);
    if(elem.hasClass('sizechart__sublabel--active')) return;
    elem.toggleClass('sizechart__sublabel--active');
    elem.siblings().toggleClass('sizechart__sublabel--active');
    let id = elem[0].id;
    if(id == 'inches') {
      $('.inches').css('display', 'table-row');
      $('.centimeters').css('display', 'none');
    } else {
      $('.inches').css('display', 'none');
      $('.centimeters').css('display', 'table-row');
    }
    

    
  });
  

  } catch(e) { console.error(e); }
})();
})();
